import script from "./ImportKaigoNoMoriManager.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportKaigoNoMoriManager.vue?vue&type=script&setup=true&lang=js"

import "./ImportKaigoNoMoriManager.vue?vue&type=style&index=0&id=6b5797fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b5797fb"]])

export default __exports__